import { IPublicClientApplication } from "@azure/msal-browser";
import {
  UnauthenticatedTemplate,
  useIsAuthenticated,
  useMsal,
} from "@azure/msal-react";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "reactstrap";
import "./login.scss";
import { authorize } from "../api/Auth/authorization";
import { useUser } from "../contexts/userContextApi";

const Login: React.FC<any> = () => {
  const isAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();
  const { instance, accounts } = useMsal();
  const { setIsAuthorize, setIsLoadingLandingPage, setRole } = useUser();
  const fetchAuthToken = async (token: any) => {
    setIsLoadingLandingPage(true);
    let res:any = await authorize(token).finally(() =>
      setIsLoadingLandingPage(false)
    );
    console.log(res, "authorization response");
    sessionStorage.setItem("jwt", res.jwtToken);
    sessionStorage.setItem("role", res.role ? res.role : "user");
    setRole(res.role ? res.role : "user");
    sessionStorage.setItem("tokenExpireTime", res.tokenExpireTime);
    return res;
  };
  useEffect(() => {
    document.body.style.overflow = "hidden";
  
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);
  useEffect(() => {
    if (isAuthenticated) {
      console.log(isAuthenticated, "isAuthenticated-------");
      const accessTokenRequest = {
        account: accounts[0],
        scopes: ["User.Read"],
      };
      const token = accessTokenRequest.account.idToken;
      const uid:any = accessTokenRequest.account.idTokenClaims?.oid;
      sessionStorage.setItem("uuid",uid);
      let res = fetchAuthToken(token);
      res.then((res) => {
        if (
          res ===
          "User is not authorized to access this resource with an explicit deny"
        ) {
          //redirectSignOut(instance);
          sessionStorage.setItem("isUnAuth", "false");
          setIsAuthorize(false);
          navigate("/UnAuthorize");
        } else {
          sessionStorage.setItem("isUnAuth", "true");
          setIsAuthorize(true);
          navigate("/drn");
        }
      });
    }
  }, [isAuthenticated]);

  const redirectSignIn = async (instance: IPublicClientApplication) => {
    await instance.handleRedirectPromise();
    instance.loginRedirect();
  };
  const redirectSignOut = (instance: IPublicClientApplication) => {
    const logoutRequest = {
      postLogoutRedirectUri: `https://dtztk57qeqd06.cloudfront.net/`,
    };

    instance.logoutRedirect(logoutRequest);
  };

  return (
    <div className="loginPage">
    <UnauthenticatedTemplate>
      {/* <div className="loginContainer">
        <div className="signInSection">
          <div className="signInContainer">
            <span className="welcomeTitle">Sign In Here</span>
            <span className="intro">GME Document Hub</span>
            <Button
              className="signInButton"
              onClick={() => redirectSignIn(instance)}
            >
              Sign in
            </Button>
          </div>
        </div>
        <div className="landingContainer d-flex">
          <img
            src="./images/CastrolLogin.png"
            alt="Login Image"
            style={{ width: "inherit" }}
          />
        </div>
      </div> */}
      <div className="wrapper">
        <div className="login-container d-flex justify-content-between flex-column">
          <div>
          <h1 className="text-default wlc-txt">Welcome to GME Document Hub</h1>
          <div className="login-form-container">
            <div className="login-form-content">
              <div className="login-buttons">
                <div className="login-button">
                  <Button
                    className="signInButton"
                    style={{fontWeight: "500"}}
                    onClick={() => redirectSignIn(instance)}
                  >
                    bp staff enter here
                  </Button>
                </div>
              </div>
            </div>
          </div></div>
          {/* <div className="login-page-info-con" style={{  
  left: "initial", fontSize:"10px !importent",color:"red"
}} >
            <h1 className="display-6 fw-normal text-default" style={{marginTop:"1.5rem"}}>
            Access guide for GME Document Hub <a target="_blank" href="https://bp365.sharepoint.com/:b:/s/SynergyReplacement/Eer6Z913pfJCqavM3YLDvroB9qH3MkBblpqAz12tYdD1hQ?e=tB0bGO" className="text-brand-primary"> Click here.</a>
            </h1>
            <h1 className="display-6 fw-normal text-default">
            Send delivery and tax related documents to <a className="text-brand-primary" href="mailto:synergydrn@uk.bp.com" onClick={()=> window.location.href = 'mailto:synergydrn@uk.bp.com'}>synergydrn@uk.bp.com</a> mailbox.
            </h1>
            <h1 className="display-6 fw-normal text-default" style={{marginTop:"1.5rem"}}>
            Raise IT tickets for technical issues – <a target="_blank" href="https://eur03.safelinks.protection.outlook.com/?url=https%3A%2F%2Fmyit.bpglobal.com%2Fmyit%3Fid%3Dmyit_ticket_submission_form&data=05%7C02%7Canwar.shaik%40bp.com%7Cd0a67bf43c5d45f2214f08dc99d91ecf%7Cea80952ea47642d4aaf45457852b0f7e%7C0%7C0%7C638554405066380958%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C0%7C%7C%7C&sdata=NRox%2BAp0Zg6%2F8WHyEAhJzZ4t4F%2Fs%2FlB5rdkOgIpXII4%3D&reserved=0" className="text-brand-primary">MyIT.</a>
            </h1>
            <h1 className="display-6 fw-normal text-default">
            Contact GME Document Hub Team at <a className="text-brand-primary" href="mailto:gmedochubsupport@castrol.com" onClick={()=> window.location.href = 'mailto:gmedochubsupport@castrol.com'}>gmedochubsupport@castrol.com</a>.</h1>
          </div> */}
          <div
  className="login-page-info-con"
  style={{ left: "initial", fontSize: "15px"}}
>
  <p style={{ marginTop: "0.5rem" }}>
    Access guide for GME Document Hub{" "}
    <a
      target="_blank"
      href="https://bp365.sharepoint.com/sites/gmedochub27/Shared%20Documents/Forms/AllItems.aspx?viewid=c2e544fe%2D8a5e%2D43f5%2Db89a%2Dfa6860879ccb&sharingv2=true&fromShare=true&at=9&CT=1780662674776&OR=OWA%2DNT%2DMail&CID=fc82f2d1%2D6298%2Dc4dd%2De3ec%2D1b44684599dd&SI=NonSentItems&clickParams=eyJYLUFwcE5hbWUiOiJNaWNyb3NvZnQgT3V0bG9vayBXZWIgQXBwIiwiWC1BcHBWZXJzaW9uIjoiMjAyNjA1MjkwMTQuMTEiLCJPUyI6Ik1hYyBPUyBYIHVuZGVmaW5lZCJ9&cidOR=Client&FolderCTID=0x012000728FF72D79EC0342A99C23A366C65FB8&id=%2Fsites%2Fgmedochub27%2FShared%20Documents%2Fgmedochub%2FTraning%2FGME%5FDochub%5FAccerss%5Fuser%5Fguide3%2E0%5Ffinal%2Epdf&parent=%2Fsites%2Fgmedochub27%2FShared%20Documents%2Fgmedochub%2FTraning"
      className="text-brand-primary"
    >
      Click here.
    </a>
  </p>
  <p style={{ marginTop: "0.5rem" }}>
    Raise IT tickets for technical issues –{" "}
    <a
      target="_blank"
      href="https://eur03.safelinks.protection.outlook.com/?url=https%3A%2F%2Fmyit.bpglobal.com%2Fmyit%3Fid%3Dmyit_ticket_submission_form"
      className="text-brand-primary"
    >
      MyIT.
    </a>
  </p>
  <p>
    Send delivery and tax related documents to{" "}
    <a
      className="text-brand-primary"
      href="mailto:synergydrn@uk.bp.com"
    >
      synergydrn@uk.bp.com
    </a>{" "}
    mailbox.
  </p>
  <p>
    Contact GME Document Hub Team at{" "}
    <a
      className="text-brand-primary"
      href="mailto:gmedochubsupport@castrol.com"
    >
      gmedochubsupport@castrol.com
    </a>.
  </p>
</div>
        </div>
      </div>
    </UnauthenticatedTemplate>
    </div>
  );
};

export default Login;
